export const Logo = ({ className = "" }) => (
  <span className={`brand ${className}`}>
    <svg className="brand-mark" width="24" height="24" viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <path
        d="M3 11V4.5A1.5 1.5 0 0 1 4.5 3H11M29 11V4.5A1.5 1.5 0 0 0 27.5 3H21M3 21v6.5A1.5 1.5 0 0 0 4.5 29H11M29 21v6.5A1.5 1.5 0 0 1 27.5 29H21"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <circle cx="16" cy="16" r="5.4" stroke="currentColor" strokeWidth="1.7" />
      <circle className="brand-dot" cx="16" cy="16" r="1.9" />
    </svg>
    <span className="brand-word">RISHI THAKOR</span>
  </span>
);
